import {Component, OnInit, Input} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent implements OnInit {

    @Input() title: string;

    @Input() backRoute: string[];

    constructor(
        private router: Router,
        private route: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public goBack() {
        this.router.navigate(this.backRoute || ['..'], {relativeTo: this.route});
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/navigation-bar/navigation-bar.component.ts